const SE = require('./locales/se')
const NO = require('./locales/no')
const FI = require('./locales/fi')

// ? ******************************************************************************************
// ? ******************************************************************************************

const APP_CATEGORY = {
  LOAN: {
    ID: 1,
    NAME: 'Unsecured'
  },
  MORTGAGE: {
    ID: 2,
    NAME: 'Mortgage'
  },
  VEHICLE: {
    ID: 3,
    NAME: 'Vehicle'
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const APPLICANT_IDS = {
  APPLICANT: 1,
  APPLICANT_CO: 2
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const APP_TYPE = {
  NEW: 1,
  REFINANCE: 2,
  NEW_PLUS_REFINANCE: 3
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const MEDIA_ID = {
  INTERNET: 1
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const MEDIA_AFF_ID = {
  LEAD: 29,
  FULL: 30,
  FULL_LEAD: 31,
  FULL_ADD_CO: 32
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const MARITAL_STATUSES = {
  MARRIED: 1,
  SINGLE: 2,
  LIVE_TOGETHER: 3,
  WIDOW: 4,
  DIVORCED: 5
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const RESIDENCE_TYPES = {
  HOUSE: 1,
  TENANT: 2,
  RENTAL: 3,
  LODGER: 4,
  OWNED_APARTMENT: 11,
  CONDOMINIUM: 12,
  PARENTS_HOME: 15,
  OWNED_BY_PARTNER: 16,
  OWNED_BY_EMPLOYER: 17,
  OTHER: 18
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const RESIDENCE_OWNERSHIP_TYPES = {
  APARTMENT: 1,
  TOWNHOUSE: 2,
  HOUSE: 3,
  HOUSE_LIM: 4,
  OTHER: 5
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const EMPLOYMENT_TYPES = {
  PERMANENT: 1,
  SELF_EMPLOYED: 2,
  FREELANCER: 6,
  RETIRED: 7,
  UNEMPLOYED: 8,
  STUDENT: 9,
  PROBATION: 10,
  PARENTAL_LEAVE: 13,
  FARMER: 14,
  FIXED_PERIOD: 15,
  WORKING_STUDENT: 17
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const SOCIAL_ECONOMIC_STATUSES = {
  WORKER: 1,
  OFFICIAL: 2,
  SENIOR_OFFICIAL: 3,
  MANAGER: 4,
  OWN_COMPANY: 5,
  FARMER: 6,
  RETIRED: 7,
  STUDENT: 8,
  OTHER: 9
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const LOAN_PURPOSE = {
  COLLECT_LOANS: 5
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const SINGLE_MARITAL_STATUSES = [2, 4, 5]

// ? ******************************************************************************************
// ? ******************************************************************************************

const OWNS_PROPERTY = [1, 2]

// ? ******************************************************************************************
// ? ******************************************************************************************

const SELF_EMPLOYED = [2]

// ? ******************************************************************************************
// ? ******************************************************************************************

const DEBT_HOLDERS = {
  APPLICANT: 1,
  APPLICANT_CO: 2,
  BOTH: 3,
  APPLICANT_PARTNER: 4,
  APPLICANT_CO_PARTNER: 5,
  APPLICANT_AND_PARTNER: 6,
  APPLICANT_CO_AND_PARTNER: 7,
  APPLICANT_IS_CO_BORROWER: 8,
  APPLICANT_CO_IS_CO_BORROWER: 9
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const OPT_OUT = {
  TYPE: {
    FIELD: 2
  },
  REASON: {
    OPT_OUT: 19
  },
  MEDIA: {
    POST: 1,
    EMAIL: 2,
    PHONE: 3
  },
  BLOCKED_FROM_SYSTEM: {
    INTERNAL: 1
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const PPC_BROKER_IDS = [1, 5, 40, 41, 69, 73, 377, 378, 379, 380, 384, 386]

// ? ******************************************************************************************
// ? ******************************************************************************************

const MULTIPLE_STEPS_VERSION_NO = 666

// ? ******************************************************************************************
// ? ******************************************************************************************

const SINGLE_STEP_VERSION_NO = 667

// ? ******************************************************************************************
// ? ******************************************************************************************

const MULTIPLE_STEPS_PV_VERSION_NO = 668

// ? ******************************************************************************************
// ? ******************************************************************************************

const SINGLE_STEP_PV_VERSION_NO = 669

// ? ******************************************************************************************
// ? ******************************************************************************************

const HIDE_REFINANCE_CHOICE_ON_PURPOSE = [5]

// ? ******************************************************************************************
// ? ******************************************************************************************

const APPLICATION_TO_OLD = 30

// ? ******************************************************************************************
// ? ******************************************************************************************

const EID = {
  YES: -1,
  NO: -2,
  MANDATORY: -3
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const BANK_ACCOUNT = {
  BEFORE: 1,
  AFTER: 2,
  NONE: 3
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const APPLICATION_STATUSES = {
  DECLINED: 80
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const CF_ACTIONS = {
  ONLINE: 4,
  ONLINE_AUTO_APPLY: 5
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const OFFER_STATUSES = {
  STANDBY: 40,
  APPLY: 40,
  HANDLING: 42,
  PROCESSING: 43,
  DECISION: 44,
  COMPLEMENT: 46,
  SEND_PN: 48,
  PN_CUSTOMER: 50,
  PN_RETURNED: 55,
  PAID_OUT: 58,
  COMMISSION: 60,
  DECLINED: 80,
  CANCELLED: 100,
  JUNK: 120
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const OFFER_SUB_STATUSES = {
  APPROVED: 4401,
  DECLINED: 4402,
  COMPLEMENT: 4403,
  QUESTION: 4404,
  CANCELLED: 4405,
  CANCELLED_TIME: 4407,
  SEND_PN_SUPPORT: 4804
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const DECLINED_APP_SUB_STATUSES = {
  TOO_LOW_AMOUNT: 10010,
  TOO_HIGH_INTEREST: 10011,
  TOO_HIGH_MONTHLY_COST: 10012,
  UNKNOWN_LENDERS: 10013,
  CONTACT_ME: 4001
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const COMPLEMENTS = {
  BEFORE: 1,
  AFTER: 2
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const BANK_CATEGORY = {
  LOAN: 5,
  CREDIT: 16
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const CREATE_APPLICATION_REQUIRED_FIELDS = [
  'brandId',
  'mediaAffId',
  'loanAmount',
  'repaymentYears',
  'ssn',
  'email',
  'phone',
  'userAgreement'
]

const DECIMAL_SIGN = ','
const THOUSAND_SEPARATOR = ' '

// ? ******************************************************************************************
// ? ******************************************************************************************

module.exports = {
  CONSTANTS: {
    APPLICANT_IDS,
    EID,
    BANK_ACCOUNT,
    CF_ACTIONS,
    APPLICATION_STATUSES,
    OFFER_STATUSES,
    OFFER_SUB_STATUSES,
    DECLINED_APP_SUB_STATUSES,
    SELF_EMPLOYED,
    OWNS_PROPERTY,
    COMPLEMENTS,
    APPLICATION_TO_OLD,
    APP_CATEGORY,
    APP_TYPE,
    MEDIA_ID,
    MEDIA_AFF_ID,
    MARITAL_STATUSES,
    RESIDENCE_TYPES,
    RESIDENCE_OWNERSHIP_TYPES,
    EMPLOYMENT_TYPES,
    SOCIAL_ECONOMIC_STATUSES,
    LOAN_PURPOSE,
    SINGLE_MARITAL_STATUSES,
    DEBT_HOLDERS,
    OPT_OUT,
    PPC_BROKER_IDS,
    MULTIPLE_STEPS_VERSION_NO,
    SINGLE_STEP_VERSION_NO,
    MULTIPLE_STEPS_PV_VERSION_NO,
    SINGLE_STEP_PV_VERSION_NO,
    HIDE_REFINANCE_CHOICE_ON_PURPOSE,
    BANK_CATEGORY,
    CREATE_APPLICATION_REQUIRED_FIELDS,
    DECIMAL_SIGN,
    THOUSAND_SEPARATOR,
    SE,
    NO,
    FI
  }
}
